// V1
import "./Loader.css";
function Loader({ theme = "" }) {
  return <div className={"dot-flashing " + theme}></div>;
}

export default Loader;
